import styled from 'styled-components';

export const Loader = styled.div`
    .loader-inner {
        display: inline-block;
        position: relative;
        vertical-align: middle;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 4px solid rgba(0, 172, 229, 0.1);
        border-top: 4px solid ${props => props.theme.brandPrimary};
        border-left: 4px solid ${props => props.theme.brandPrimary};
        animation: loader 1s cubic-bezier(0.32, -0.47, 0.01, 1.07) 0s infinite;
    }

    @keyframes loader {
        0% {
            transform: rotate(360deg);
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/loading/LoadingComponentStyle.js